<template>
  <ButtonSpinner/>
</template>

<script>

import ButtonSpinner from '@/components/ButtonSpinner.vue';
import { initExemptionByAccessToken } from '@/service/api/exemptions.api';

export default {
  components: { ButtonSpinner },
  async mounted() {
    await this.initExemption();
  },
  computed: {
    exemptionInitToken() {
      return this.$route.params.exemptionInitToken;
    },
    clientSlug() {
      return this.$route.params.clientSlug;
    },
  },
  methods: {
    async initExemption() {
      try {
        const { data } = await initExemptionByAccessToken(this.exemptionInitToken, this.clientSlug);

        if (data && data.exemptionFormUrl) {
          window.location.replace(data.exemptionFormUrl);
        } else {
          await this.$router.push({ name: 'oops', params: { messageShortCode: 'token_expired' } });
        }
      } catch (error) {
        await this.$router.push({ name: 'oops', params: { messageShortCode: 'token_expired' } });
      }
    },
  },
}
</script>
